export const NON_MEMBER = "non-member";
export const LEAD = "lead";
export const EX_MEMBER = "ex-member";
export const MEMBER = "member";
export const FRONTDESK = "frontdesk";
export const ADMINISTRATIVE = "administrative";
export const COACH = "coach";
export const ADMIN = "admin";
export const ADMINISTRATOR = "administrator";
export const SUPERUSER = "superuser";

/**
 * This represents roles which can use control panel. When using roles for
 * actions related only to control panel users, this is the set of roles
 * to use. (e.g. checking permissions)
 */
export type StaffRole =
  | typeof FRONTDESK
  | typeof ADMINISTRATIVE
  | typeof COACH
  | typeof ADMIN
  | typeof ADMINISTRATOR
  | typeof SUPERUSER;

/**
 * All possible user roles. Use when needing to include users who cannot access
 * control panel (e.g. members, leads).
 */
export type AllRoles =
  | StaffRole
  | typeof NON_MEMBER
  | typeof LEAD
  | typeof EX_MEMBER
  | typeof MEMBER;
